module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "210px"
    }
  }, [_vm._l((_vm.list), function(item) {
    return [_c('el-form-item', {
      key: item.id,
      attrs: {
        "label": item.flag_desc
      }
    }, [(item.editing) ? _c('el-input', {
      directives: [{
        name: "focus",
        rawName: "v-focus"
      }],
      attrs: {
        "type": "textarea",
        "rows": 7,
        "placeholder": "请输入内容"
      },
      on: {
        "blur": function($event) {
          return _vm.inputBlur(item)
        }
      },
      model: {
        value: (item.item_bns),
        callback: function($$v) {
          _vm.$set(item, "item_bns", $$v)
        },
        expression: "item.item_bns"
      }
    }) : _c('span', {
      staticClass: "bntext",
      on: {
        "dblclick": function($event) {
          return _vm.boxClick(item)
        }
      }
    }, [_vm._v(_vm._s(item.item_bns))]), _vm._v(" "), _c('span', {
      staticClass: "frm-tips"
    }, [_vm._v("* 双击进行编辑，点击空白区域自动保存")]), _vm._v(" "), _c('br')], 1)]
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0f4f4a65", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f4f4a65"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/setting/itemsflag/index.vue
// module id = 2470
// module chunks = 0